import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./components/pages/Home";

import Convidado from "./components/pages/Convidado";
import Convite from "./components/pages/Convite";
import QRCodeGenerator from "./components/pages/QRCodeGenerator";
import ValidarConvite from "./components/pages/ValidarConvite";


 

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Rota de login fora da estrutura protegida */}
        <Route path="/" element={<Login />} />
        <Route path="/qr" element={<QRCodeGenerator />} />
        <Route path="/validar/:code" element={<ValidarConvite />} />
       
  

         {/* http://localhost:3000/qr?content=Ol%C3%A1+Justino!&filename=convite_justino  
         window.open(`http://localhost:3000/qr?content=OláMundo&filename=meu_qr`, "_blank");

         */}
        <Route path="qr" element={<QRCodeGenerator />} />  
      
 
        {/* Rotas protegidas dentro de Home */}
        <Route
          path="/*"
          element={
          //  <Home />
          
           <ProtectedRoute>
            <Home />
            </ProtectedRoute>

       

          }
        >
             <Route path="convidados/:id" element={<Convidado />} />
            <Route path="convites" element={<Convite />} />
             

        </Route>
      </Routes>
    </Router>
  );
};

export default App;

